import {
  useBlockRouteEffect,
  useRecentProjectEffect,
  useRecentRegionEffect,
  useRecentServiceEffect,
  useRequiredParamEffect,
  useServiceRedirectEffect,
  useServiceRouteEffect,
  useToastParamEffect,
  useToastStateEffect,
} from '../hooks';

import type { PropsWithChildren } from 'react';
import type { PageComponentProps } from '@kc-console/context';

interface ClientSideGuardProps extends PropsWithChildren {
  pageProps: PageComponentProps;
}

const ClientSideGuard = ({ children }: ClientSideGuardProps) => {
  useBlockRouteEffect();
  useRecentServiceEffect();
  useRequiredParamEffect();
  useToastParamEffect();
  useRecentRegionEffect();
  useRecentProjectEffect();
  useToastStateEffect();
  useServiceRedirectEffect();
  useServiceRouteEffect();

  return <>{children}</>;
};

export default ClientSideGuard;
